import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import ChevronLeft from '../../../images/icon_chevron_left_white.svg'
import { CssSeoText } from '../seoContent/styles'

export const StyledDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};

  summary {
    position: relative;
    cursor: pointer;
    padding: 0.5em 1.2em 0.5em 0.6em;
    background-color: ${themeStyles.colors.darkGreys[4].main};
    border-bottom: 1px solid ${themeStyles.colors.darkGreys[2].main};

    list-style: none;
    &::-webkit-details-marker {
      display: none;
    }

    &:after {
      content: '';
      height: 2.6em;
      width: 0.6em;
      background: url('${ChevronLeft}') center no-repeat;

      position: absolute;
      top: 50%;
      right: 1.1em;
      transform-origin: center;
      transform: translateY(-50%) rotate(-90deg);

      transition: 0.2s;
    }
  }

  details {
    &[open] summary:after {
      transform: translateY(-50%) rotate(90deg);
    }

    > div {
      ${CssSeoText}
      padding: 0.7em;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
`
